window.Reverb = window.Reverb || {};
Reverb.AjaxFetchOnPageLoad = (function () {
  const fetchOnPageLoad = '[data-fetch-on-load]';

  function init() {
    $(fetchOnPageLoad).each(function () {
      const $container = $(this);
      const $spinOnFetch = $($container.data('spin-on-fetch'));
      $spinOnFetch.spin();
      const url = $container.data('fetch-on-load');

      // ensure that requests are going to the current origin
      const u = new URL(url, window.origin);
      if (u.origin !== window.origin) {
        return;
      }

      $.ajax({
        url: url,
        beforeSend(xhr) { xhr.setRequestHeader('Vary', 'X-Requested-With'); },
      }).done((response) => {
        $container.html(response);
        $container.trigger('reverb.ajax_load.complete');
        $spinOnFetch.stopSpinner();
      });
    });
  }

  return {
    init,
  };
}());

$(document).ready(Reverb.AjaxFetchOnPageLoad.init);



// WEBPACK FOOTER //
// ./src/components/legacy/ajax_fetch_on_page_load.js